export default function useGetDescription({ brand, description }) {
  return brand ?? description ?? '';
}
